module.exports = __webpack_public_path__ + "static/media/recent-withdraw.54bba27d.svg";